module.exports = __webpack_public_path__ + "static/media/car_cancelled.52c94bab.svg";